import {Injectable} from '@angular/core';
import {FuseMockApiService} from '@fuse/lib/mock-api/mock-api.service';
import {
    categories as categoriesData,
    estates as statesData,
    honeyTokens,
    projects as projectsData
} from 'app/mock-api/apps/proyects/data';
import {cloneDeep} from 'lodash-es';

@Injectable({providedIn: 'root'})
export class ProyectsMockApi {
    private _states: any[] = statesData;
    private _projects: any[] = projectsData;
    private _categories: any[] = categoriesData;
    private _honeyTokens: any[] = honeyTokens;

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {
        // -----------------------------------------------------------------------------------------------------
        // @ States - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/apps/project/states')
            .reply(() => {
                // Clone the categories
                const states = cloneDeep(this._states);

                // Sort the categories alphabetically by title
                states.sort((a, b) => a.title.localeCompare(b.title));

                return [200, states];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Projects - GET
        // -----------------------------------------------------------------------------------------------------
        /*this._fuseMockApiService
            .onGet('api/project')
            .reply(() => {
                // Clone the courses
                const courses = cloneDeep(this._projects);
                return [200, courses];
            });*/

        // -----------------------------------------------------------------------------------------------------
        // @ project - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/apps/projects/project')
            .reply(({request}) => {
                // Get the id from the params
                const id = request.params.get('id');

                // Clone the contacts
                const projects = cloneDeep(this._projects);

                // Find the contact
                const project = projects.find(item => item.id === id);

                // Return the response
                return [200, project];
            });


        // -----------------------------------------------------------------------------------------------------
        // @ Categories - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/apps/projects/categories')
            .reply(() => {
                // Clone the contacts
                const categories = cloneDeep(this._categories);

                // Return the response
                return [200, categories];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ HoneyTokens - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/apps/honeytokens')
            .reply(() => {
                // Clone the courses
                const honeytokens = cloneDeep(this._honeyTokens);
                return [200, honeytokens];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ project - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/apps/honeytoken')
            .reply(({request}) => {
                // Get the id from the params
                const id = request.params.get('id');

                // Clone the contacts
                const honeyTokens = cloneDeep(this._honeyTokens);

                // Find the contact
                const honeyToken = honeyTokens.find(item => item.id === id);

                // Return the response
                return [200, honeyToken];
            });
    }
}
